var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "generate-btn-box", class: {} }, [
    _c(
      "div",
      {
        staticClass: "generate-btn",
        class: { disabled: _vm.isDone === false || this.loading },
        on: { click: _vm.applyImage },
      },
      [
        _vm._v("\n    " + _vm._s(_vm._f("trans")("Continue")) + "\n\n    "),
        !_vm.loading
          ? _c("i", { staticClass: "far fa-arrow-right font-size-150" })
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c("i", { staticClass: "fa fa-spin btn-loading-animation" })
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }